<template>
  <div class="iconList">
    <div class="iconRow">
      <div
        :id="'item' + (index + 1)"
        class="iconItem"
        v-for="(item, index) in iconList"
        @click="gotoPage(item.page)"
        :key="index"
      >
        <div class="iconCol">
          <div class="iconWrapper">
            <van-image class="iconImg" :src="item.imgUrl" />
            <div class="iconTitle">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image } from "vant";
Vue.use(Image);

export default {
  name: "IconList",
  components: {},
  props: {
    icons: {
      type: Array,
    },
  },
  data() {
    return {
      iconList: [
        {
          imgUrl: require("@/assets/img/home/goodsForecast.png"),
          name: this.$t.home.shipNow,
          page: "freightPriceCalculator",
        },
        {
          imgUrl: require("@/assets/img/home/orderDetail.png"),
          name: this.$t.home.orderDetail,
          page: "orderDetail",
        },
        {
          imgUrl: require("@/assets/img/home/accountList.png"),
          name: this.$t.home.accountList,
          page: "accountList",
        },
        {
          imgUrl: require("@/assets/img/home/shippingAddress.png"),
          name: this.$t.home.shippingAddress,
          page: "shippingAddress",
        },
        {
          imgUrl: require("@/assets/img/home/freightInquiry.png"),
          name: this.$t.home.freightInquiry,
          page: "freightInquiry",
        },
        // {
        //   imgUrl: require("@/assets/img/home/cargoInquiryList.png"),
        //   name: this.$t.home.cargoInquiry,
        //   page: "cargoInquiryList",
        // },
        // {
        //   imgUrl: require("@/assets/img/home/freightPriceCalculator.png"),
        //   name: this.$t.home.freightPriceCalculator,
        //   page: "freightPriceCalculator",
        // },
      ],
    };
  },
  methods: {
    gotoPage(path) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: path,
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
// 是设计图是三杯图
.iconList {
  $-ipd: 8.54%;
  #item1 {
    .iconCol {
      padding: 0px $-ipd $-ipd $-ipd !important;
    }
  }
  #item2 {
    .iconCol {
      padding: 0px $-ipd $-ipd 0px !important;
    }
  }
  #item3 {
    .iconCol {
      padding: 0px $-ipd $-ipd 0px !important;
    }
  }
  #item4 {
    .iconCol {
      padding: 0px $-ipd $-ipd $-ipd !important;
    }
  }
  #item5 {
    .iconCol {
      padding: 0px $-ipd $-ipd 0px !important;
    }
  }
  .iconRow {
    margin-top: 2%;
    .iconItem {
      display: inline-block;
      width: 33.33%;
      .iconWrapper {
        background: #f9fafd;
        border-radius: 10px;
        text-align: center;
        padding: 10px;
        .iconImg {
          height: 40px;
          width: 40px;
          margin-bottom: 5px;
          .ImgIcon {
            width: 100%;
          }
          ::v-deep .van-image__img {
            width: 100%;
          }
          ::v-deep .van-image__error {
            width: 100%;
          }
        }
      }
      .iconTitle {
        font-size: 12px;
        font-family: Helvetica;
        font-weight: 500;
        color: #000;
        width: 100%;
        text-align: center;
        margin: auto;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
        white-space: normal;
      }
    }
  }
}
</style>
